import { render, staticRenderFns } from "./joinDetail.vue?vue&type=template&id=3c6490c4&scoped=true"
import script from "./joinDetail.vue?vue&type=script&lang=js"
export * from "./joinDetail.vue?vue&type=script&lang=js"
import style0 from "./joinDetail.vue?vue&type=style&index=0&id=3c6490c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6490c4",
  null
  
)

export default component.exports